import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Boot from './Boot';

import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

/* import Push from 'push.js';

if(!Push.Permission.has()) {
    Push.Permission.request(()=>{}, ()=>{});
}

console.log(Push.Permission.has());
 */
ReactDOM.render((
    <div>
        <Router>
            <Boot />
        </Router>
        <ToastContainer />
    </div>
), document.getElementById('root'));

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js